// Update warnings (DR-0098; Theo, 13 Oct 2026: "we need a system for telling players when we're pushing an update,
// maybe some kind of like red warning we can push across all effected games saying "UPDATE INCOMING, SERVER RESET"").
// The home game server holds at most one notice, in memory; every ACT page polls GET /notice there and shows it as a
// red bar counting down to the reset. Plain types and limits only, for the server, the pages and
// tools/ops/server-notice.mjs.

/** A warning before a server reset: its words, and when the reset is due (epoch ms, the server's clock). */
export type ServerNotice = { id: string; text: string; resetAt: number };

/** GET /notice: the notice (null when there's none), the server process's boot id (a new one means it has been
 *  replaced, so the reset has happened), and its clock (epoch ms). */
export type ServerNoticeReply = { notice: ServerNotice | null; bootId: string; now: number };

/** A notice's longest text. */
export const SERVER_NOTICE_MAX_TEXT = 120;
/** A notice's reset is at least this far ahead when it's put up, and at most this far (ms). */
export const SERVER_NOTICE_MIN_LEAD_MS = 10_000;
export const SERVER_NOTICE_MAX_LEAD_MS = 2 * 60 * 60_000;
/** A notice goes this long after its reset, if the reset never comes (ms): a push that changed nothing server-side
 *  restarts nothing (13 Oct 2026: Railway skipped all three servers and the bar waited out the old 15 minutes). The
 *  slowest server yet came back 3 minutes after its countdown. */
export const SERVER_NOTICE_LINGER_MS = 6 * 60_000;
